/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationSystem from "react-notification-system";
import Switch from "react-switch";
import {
  AddMedicationTag,
  getCity,
  getCountry,
  geFeturedtMedicationcategory,
} from "../../../Listfunction";
import { style } from "../../../variables/Variables";
import Select from "react-select";

class addMedicationTags extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "1",
      radioVariant: "1",
      Keyword: "",
      medicationcategory: [],
      m_category: "0",
      m_categoryError: null,
      KeywordError: null,
      countrydetails: [],
      country: [],
      countryError: null,
      show_in_app: "2",
      alert: null,
      errormessage: "",
      _notificationSystem: null,
      cardHidden: true,
      errormessages: [],
      selectTags: "",
      switchToNext: true,
    };

    this.handlesubmit = this.handlesubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.onChange = this.onChange.bind(this);
  }
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Keyword</b> - Added Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      this.props.history.push("/admin/medicationTags");
    }, 3000);
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  componentDidMount = async () => {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    let compelte = 1;
    let pg_no = 1;
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    while (compelte == 1) {
      await geFeturedtMedicationcategory(obj, pg_no)
        // .then((response) => response.json())
        .then((response) => {
          const mdata = response.data;
          if (mdata.data.length == 0) {
            compelte = 0;
          } else {
            var array1 = this.state.medicationcategory;
            var array2 = array1.concat(mdata.data);
            this.setState({
              medicationcategory: array2,
            });
          }
          // this.category_drop();3
          // console.log(response.data);
        });
      pg_no++;
    }
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );

    var country_id = "1";

    getCountry(obj).then((res) => {
      let pcItems = [];
      res.data.map((x, i) => {
        pcItems.push({ value: x.id, label: x.country_name });
      });
      this.setState({
        countrydetails: pcItems,
      });
    });
  };
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handlesubmit = (e) => {
    let error = false;
    // console.log(this.state.medicationcategoryname.length);
    this.setState({ errormessages: [] });
    if (this.state.Keyword.length == 0) {
      error = true;
      this.setState({
        KeywordError: (
          <small className="text-danger">Keyword is required.</small>
        ),
      });
    } else {
      this.setState({ KeywordError: null });
    }
    /*
    if (this.state.country.length == 0) {
      error = true;
      this.setState({
        countryError: (
          <small className="text-danger">country is required.</small>
        ),
      });
    } else {
      this.setState({ countryError: null });
    }
    */
    var category_id = this.state.m_category;

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      let countryid = [];
      this.state.country.map((c) => {
        countryid.push(c.value);
      });

      var sia = "";
      if (this.state.show_in_app == "1") {
        sia = "1";
      } else if (this.state.show_in_app == "2") {
        sia = "0";
      }

      AddMedicationTag(
        this.state.Keyword,
        category_id,
        obj,
        this.state.switchToNext ? "raya" : "claims"
      )
        .then((res) => {
          // alert('Medication data added');
          //console.log(res.data.success);
          if (res.data.success === false) {
            const message = res.data.data;

            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ errormessages: ermessage });
              this.setState({
                KeywordError: (
                  <small className="text-danger">{message.Keyword}</small>
                ),
              });
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
            this.setState({
              Keyword: "",
            });
            // this.props.history.push('/admin/medication-category');
          }
        })
        .catch((error) => {
          this.handleNetworkError("bl");
          console.log(error, "== error");
        });
    }
  };
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  render() {
    const medicaioncat = this.state.medicationcategory;
    console.log(this.state.medicationcategory, "medication category");
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={6}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                    <FormGroup>
                      <br></br>
                      <ControlLabel style={{ display: "block" }}>
                        Change To Claim Tags
                      </ControlLabel>
                      <div
                        className="OrderType_switch"
                        style={{ marginTop: 16, marginBottom: 16 }}
                      >
                        <Switch
                          checked={this.state.switchToNext}
                          onChange={(e) => {
                            const isRaya = !this.state.switchToNext;
                            this.setState({
                              switchToNext: isRaya,
                              Keyword: "",
                            });
                          }}
                          onColor="#24cc63"
                          offColor="#24cc63"
                          onHandleColor="#f7f7f7"
                          offHandleColor="#6c757d"
                          height={32}
                          width={70}
                          uncheckedIcon={
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "100%",
                                width: "92%",
                                color: "#ffffff",
                                fontSize: "23px",
                              }}
                            >
                              <i className="fas fa-money-check-alt"></i>
                            </div>
                          }
                          checkedIcon={
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "93%",
                                width: "110%",
                                color: "white",
                                fontSize: "27px",
                              }}  
                            >
                              <i className="fa fa-shopping-cart"></i>
                            </div>
                          }
                          className="react-switch"
                          id="small-radius-switch"
                        />
                      </div>
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Tag Type</ControlLabel>
                      <select
                        onChange={(event) => {
                          this.setState({ selectTags: event.target.value });
                        }}
                        value={this.state.switchToNext ? "raya" : "claims"}
                        className="form-control"
                        disabled
                      >
                        <option value="raya">raya</option>
                        <option value="claims">claims</option>
                      </select>
                    </FormGroup>
                    {!!this.state.switchToNext ? (
                      <>
                        <FormGroup>
                          <ControlLabel>Medication Category</ControlLabel>
                          <select
                            className="react-select primary form-control"
                            name="m_category"
                            value={this.state.m_category}
                            onChange={(event) => {
                              const value = event.target.value;
                              this.setState({
                                m_category: value,
                                m_categoryError:
                                  value === "0" ? (
                                    <small className="text-danger">
                                      Medication Category is required.
                                    </small>
                                  ) : null,
                              });
                            }}
                          >
                            <option value="0">
                              Select Medication Category
                            </option>
                            {medicaioncat.map((cus) => (
                              <option key={cus.id} value={cus.id}>
                                {cus.category_name}
                              </option>
                            ))}
                          </select>
                          {this.state.m_categoryError}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Keyword</ControlLabel>
                          <FormControl
                            name="Keyword"
                            value={this.state.Keyword || ""}
                            onChange={(event) => {
                              const value = event.target.value;
                              this.setState({
                                Keyword: value,
                                KeywordError:
                                  value === "" ? (
                                    <small className="text-danger">
                                      Keyword is required.
                                    </small>
                                  ) : null,
                              });
                            }}
                            placeholder="Enter Keyword"
                            type="text"
                          />
                          {this.state.KeywordError}
                        </FormGroup>
                      </>
                    ) : (
                      <FormGroup>
                        <ControlLabel>Keyword</ControlLabel>
                        <FormControl
                          name="Keyword"
                          value={this.state.Keyword || ""}
                          onChange={(event) => {
                            const value = event.target.value;
                            this.setState({
                              Keyword: value,
                              KeywordError:
                                value === "" ? (
                                  <small className="text-danger">
                                    Keyword is required.
                                  </small>
                                ) : null,
                            });
                          }}
                          placeholder="Enter Keyword"
                          type="text"
                        />
                        {this.state.KeywordError}
                      </FormGroup>
                    )}

                    {/* 
                    <FormGroup>
                      <ControlLabel>Country</ControlLabel>
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        placeholder="country"
                        name="country"
                        closeMenuOnSelect={false}
                        isMulti
                        value={this.state.country}
                        onChange={(value) =>
                          this.setState({
                            country: value,
                          })
                        }
                        options={this.state.countrydetails}
                      />

                      {this.state.countryError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Show in App?</ControlLabel>
                      <div className="report_feature">
                        <Radio
                          number="7"
                          option="1"
                          name="show_in_app"
                          onChange={this.onChange}
                          checked={this.state.show_in_app === "1"}
                          label="Yes"
                        />{" "}
                        &nbsp;
                        <Radio
                          number="8"
                          option="2"
                          name="show_in_app"
                          onChange={this.onChange}
                          checked={this.state.show_in_app === "2"}
                          label="No"
                        />
                      </div>
                    </FormGroup>
*/}
                    <Button
                      onClick={this.handlesubmit}
                      className="btn-color"
                      fill
                    >
                      Submit
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default addMedicationTags;
